<script setup>
import moment from "moment";
moment.locale("id");
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="flex flex-col gap-3 items-center justify-center"
          v-if="sioID == null"
        >
          <img
            src="../../../assets/images/notfound.png"
            alt=""
            :style="{
              width: '361px',
            }"
          />
          <h4 class="text-red-700 font-inter font-bold text-4xl pt-5">
            Anda belum melakukan pengajuan CoC
          </h4>
          <p class="text-center text-slate-500">
            Jangan Khawatir, klik tombol di bawah ini untuk memulai <br />
            proses pembuatan CoC ID Anda.
          </p>
          <v-btn
            class="bg-red-600 text-white capitalize"
            @click="$router.push('/sio')"
          >
            Buat CoC ID Sekarang
          </v-btn>
        </div>
        <div class="flex w-full justify-center" v-if="sioID != null">
          <div class="w-full">
            <!-- <div
              v-if="
                dataSio.status == 0 ||
                dataSio.status == 1 ||
                dataSio.status == 2 ||
                dataSio.status == -3
              "
              class="flex flex-col gap-3 items-center mt-5 py-3"
            >
              <img
                src="../../../assets/images/notfound.png"
                alt=""
                :style="{
                  width: '361px',
                }"
              />
              <h4 class="pt-5 text-red-700 font-inter font-bold text-4xl">
                Penilaian Calon PJO
              </h4>
              <p class="text-center text-slate-500">
                Pengajuan CoC anda sedang dilakukan evaluasi oleh admin.
              </p>
              <v-btn
                class="bg-red-600 text-white capitalize"
                @click="$router.push('/sio')"
              >
                Lihat Detail Pengajuan CoC
              </v-btn>
            </div>
            <div v-else> -->
            <!-- <div> -->
            <h2 class="text-red-600 text-3xl font-inter font-bold">
              Penilaian Calon PJO
            </h2>
            <p class="text-gray-500">
              Sini-Saja membantu mengelola & memantau perkembangan kegiatan
              kontraktor
            </p>

            <div class="evaluation-table-container mt-5">
              <table class="evaluation-form-table">
                <tbody>
                  <tr class="evaluation-table-heading">
                    <td colspan="2" style="background-color: #f8d7da">
                      Form Penilaian Calon Penanggung Jawab
                    </td>
                  </tr>
                  <tr>
                    <td>Nama Calon PJO</td>
                    <td>
                      {{
                        dataPJO !== null && dataPJO !== undefined
                          ? dataPJO.nama !== undefined && dataPJO.nama !== null
                            ? dataPJO.nama
                            : "-"
                          : "-"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Perusahaan</td>
                    <td>
                      {{
                        dataPJO !== null && dataPJO !== undefined
                          ? dataPJO.perusahaan !== undefined &&
                            dataPJO.perusahaan !== null
                            ? dataPJO.perusahaan
                            : "-"
                          : "-"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Tanggal Presentasi</td>
                    <td>
                      {{
                        dataPJO !== null && dataPJO !== undefined
                          ? dataPJO.tanggalPresentasi !== undefined &&
                            dataPJO.tanggalPresentasi !== null
                            ? moment(dataPJO.tanggalPresentasi).format("LL")
                            : "-"
                          : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <table
              class="table w-100 rounded table-borderless mt-3"
              style="overflow: hidden; font-family: 'Inter-Medium', serif"
            >
              <thead
                style="
                  font-family: 'Inter-Medium', serif;
                  line-height: 24px;
                  color: #28293d;
                "
              >
                <tr style="max-height: 5vh">
                  <th class="p-2 text-nowrap fs-5" style="width: 15%">
                    <b>Total NC : {{ totalData - totalDataInfo }}</b>
                  </th>
                  <th class="p-2 text-nowrap fs-5" style="width: 25%">
                    <b>Total NC Approved : {{ totalDataApproved }}</b>
                  </th>
                  <th class="p-2 text-nowrap fs-5" style="width: 20%">
                    <b>Total NC Revision : {{ totalDataRevision }}</b>
                  </th>
                  <th class="p-2 text-nowrap fs-5" style="width: 40%">
                    <b>
                      Persentasi NC Approved :
                      {{
                        totalData > totalDataInfo
                          ? (
                              (totalDataApproved /
                                (totalData - totalDataInfo)) *
                              100
                            ).toFixed(0) + "%"
                          : "0%"
                      }}
                    </b>
                  </th>
                </tr>
              </thead>
            </table>

            <div class="overflow-x-auto w-full">
              <v-data-table-server
                v-model:items-per-page="dataTable.pagination.itemsPerPage"
                :items-per-page-options="[5, 10, 25, 50, 100]"
                :headers="dataTable.headers"
                :items="dataTable.items"
                class="rounded-lg shadow-md"
                :items-length="dataTable.pagination.totalItems"
                @update:options="getListNC"
              >
                <template v-slot:item="{ item, index }">
                  <tr
                    class="border-b border-gray-950 h-16"
                    :class="{ 'bg-gray-50': index % 2 !== 0 }"
                  >
                    <td class="w-[50px] min-w-[50px] text-center">
                      {{ index + 1 }}
                    </td>
                    <td class="min-w-60">
                      {{
                        item.jenisAspek != null
                          ? capitalized(item.jenisAspek)
                          : "Administrasi"
                      }}
                      -
                      {{ item.aspek != null ? item.aspek : "Administrasi" }}
                      - {{ item.kriteriaPenilaian }}
                    </td>
                    <td>
                      {{ item.catatan }}
                    </td>
                    <td>
                      {{
                        item.namaKustodian == null ? "-" : item.namaKustodian
                      }}
                    </td>
                    <td>
                      {{
                        item.dueDate != null
                          ? moment(item.dueDate).format("DD/MM/YYYY")
                          : "-"
                      }}
                    </td>
                    <td>
                      <div v-if="item.status == 'open'">
                        <span
                          class="badge"
                          style="background-color: #b99b22; color: #f2f0f0"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-circle"
                            style="
                              font-size: 0.5em;
                              margin-bottom: 0.25em;
                              color: #f2f0f0;
                            "
                          />
                          Opened</span
                        >
                      </div>
                      <div
                        v-if="item.status == 'review' && item.assets != null"
                      >
                        <span
                          class="badge"
                          style="background-color: #b99b22; color: #f2f0f0"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-circle"
                            style="
                              font-size: 0.5em;
                              margin-bottom: 0.25em;
                              color: #f2f0f0;
                            "
                          />
                          Opened</span
                        >
                      </div>
                      <div v-if="item.status == 'review'">
                        <span
                          class="badge"
                          style="background-color: #ec8a29; color: #f2f0f0"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-circle"
                            style="
                              font-size: 0.5em;
                              margin-bottom: 0.25em;
                              color: #f2f0f0;
                            "
                          />
                          Under Review</span
                        >
                      </div>

                      <div v-else-if="item.status == 'accept'">
                        <span
                          class="badge"
                          style="background-color: #02a12d; color: #f2f0f0"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-circle"
                            style="
                              font-size: 0.5em;
                              margin-bottom: 0.25em;
                              color: #f2f0f0;
                            "
                          />
                          Approved</span
                        >
                      </div>
                      <div v-else-if="item.status == 'reject'">
                        <span
                          class="badge"
                          style="background-color: #df4d20; color: #f2f0f0"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-circle"
                            style="
                              font-size: 0.5em;
                              margin-bottom: 0.25em;
                              color: #f2f0f0;
                            "
                          />
                          Need Revision</span
                        >
                      </div>
                      <div v-else-if="item.status == 'info'">
                        <span
                          class="badge"
                          style="background-color: #209cdf; color: #f2f0f0"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-circle"
                            style="
                              font-size: 0.5em;
                              margin-bottom: 0.25em;
                              color: #f2f0f0;
                            "
                          />
                          Information</span
                        >
                      </div>
                    </td>
                    <td class="w-auto">
                      <div
                        class="input-group min-w-80 w-80"
                        :hidden="
                          item.status == 'accept' || item.status == 'info'
                        "
                      >
                        <input
                          type="file"
                          :ref="'fileNC' + index"
                          accept=".pdf"
                          class="form-control fs-9 min-w-32"
                          id="inputGroupFile04"
                          aria-describedby="inputGroupFileAddon04"
                          aria-label="Upload"
                          @change="handleChangeFile(index)"
                          multiple
                        />
                        <button
                          class="btn btn-outline-secondary fs-9 border border-start-0"
                          type="button"
                          id="inputGroupFileAddon04"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-cloud-arrow-up"
                            style="color: #000000"
                          />
                        </button>
                      </div>

                      <template
                        v-if="
                          item.assets != null &&
                          Array.isArray(JSON.parse(item.assets))
                        "
                      >
                        <ul>
                          <li
                            v-for="(asse, idx) in JSON.parse(item.assets)"
                            :key="idx"
                          >
                            <a
                              class="text-danger cursor-pointer text-nowrap"
                              @click="viewFile(asse.filename)"
                              >{{ asse.actual_name }}</a
                            >
                          </li>
                        </ul>
                      </template>
                      <template
                        v-else-if="
                          item.assets != null &&
                          !Array.isArray(JSON.parse(item.assets))
                        "
                      >
                        <a
                          class="text-danger cursor-pointer"
                          @click="viewFile(JSON.parse(item.assets).filename)"
                          >{{ JSON.parse(item.assets).actual_name }}</a
                        >
                      </template>
                    </td>
                    <td>
                      {{ item.rejectReason != null ? item.rejectReason : "-" }}
                    </td>
                    <td class="text-center">
                      <v-tooltip text="Simpan">
                        <template v-slot:activator="{ props }">
                          <button
                            v-bind="props"
                            type="button"
                            class="btn btn-outline-success color-approve"
                            @click="clickSimpan(index)"
                            :hidden="
                              item.status == 'accept' || item.status == 'info'
                            "
                          >
                            <font-awesome-icon icon="fa-solid fa-save" />
                          </button>
                        </template>
                      </v-tooltip>
                    </td>
                  </tr>
                </template>
              </v-data-table-server>
            </div>
            <!-- </div> -->
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
</template>

<style scoped>
.ellipsis {
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.color-approve {
  background: #b6f4d5;
  border: none;
}
/* :deep(table) {
  table-layout: auto !important;
  width: max-content !important;
  min-width: 100%;
} */
:deep(thead) {
  background-color: #fecaca;
}
</style>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
// import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "../../../GlobalDataMixin";
// import Datepicker from "vuejs3-datepicker"
import axios from "axios";
import Swal from "sweetalert2";
import {
  API_BASE_URL,
  CMS_GET_SIOID,
  CMS_GET_KONTRAKTOR_JADWALNILAI,
  CMS_GET_PENILAIANDETAIL,
  CMS_GET_NC_LIST,
  CMS_UPLOAD_FILE_PK,
  CMS_SET_NC,
  // CMS_DOWNLOAD,
  CMS_VIEW_DOCUMENT,
} from "@/constants";

import "@/pages/sio/assets/penilaian-presentasi.css";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import {
  CreateDataTableObject,
  SetDataTableResponse,
} from "@/utilities/DataTableHelpers";

const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
const url_get_jadwal = API_BASE_URL + CMS_GET_KONTRAKTOR_JADWALNILAI;
const url_get_penilaiandetail = API_BASE_URL + CMS_GET_PENILAIANDETAIL;
const url_get_list_nc = API_BASE_URL + CMS_GET_NC_LIST;
const url_upload_file_nc = API_BASE_URL + CMS_UPLOAD_FILE_PK;
const url_set_nc = API_BASE_URL + CMS_SET_NC;
// const url_download = API_BASE_URL + CMS_DOWNLOAD
const url_view_document = API_BASE_URL + CMS_VIEW_DOCUMENT;

const max_file_size = 5; // MB

export default {
  mixins: [GlobalDataMixin],
  name: "PenilaianPresentasi",
  components: {
    // FontAwesomeIcon,
    DefaultLayout,
    // Datepicker
  },
  data() {
    return {
      dataTable: CreateDataTableObject([
        { title: "No.", align: "start", sortable: false, width: "3px" },
        {
          title: "Aspek & Kriteria Penilaian",
          align: "start",
          sortable: false,
          width: "15%",
        },
        {
          title: "Catatan",
          align: "start",
          sortable: false,
          width: "24%",
        },
        { title: "Evaluator", align: "start", sortable: false, width: "12.5%" },
        { title: "Batas Waktu", align: "start", sortable: false, width: "8%" },
        { title: "Status", align: "start", sortable: false, width: "7.5%" },
        { title: "File", align: "start", sortable: false, width: "10%" },
        {
          title: "Alasan Tolak",
          align: "start",
          sortable: false,
          width: "15%",
        },
        { title: "", align: "start", sortable: false, width: "auto" },
      ]),
      currentPage: 1,
      perPage: 5,
      totalData: 0,
      role: "",
      tempAssets: null,
      isLoading: true,
      sioID: null,
      kontraktorid: null,
      id: null,
      idPenjadwalan: null,
      idPenilaianAdmin: null,
      idPenilaianKompetensi: [],
      idPenilaianMateri: [],
      dataSio: [],
      jenisPenilaian: ["administrasi", "kompetensi", "presentasi"],
      dataPJO: {
        nama: null,
        perusahaan: null,
        tanggalPresentasi: null,
      },
      dataPenilaianAdmin: [],
      dataPenilaianKompetensi: [],
      dataPenilaianMateri: [],
      dataPenilaianKustodian: [],
      activeTab: "administrative",

      evaluationCustodians: [
        {
          name: "Giorno Giovanna",
          aspek: "Teknis",
          statusDocument: "Submitted",
          submitDate: "10/FEB/2025",
        },
        {
          name: "Buccharati Ivanka Julian Putra",
          aspek: "Aspek Keselamatan Pertambangan",
          statusDocument: "-",
          submitDate: "10/FEB/2025",
        },
        {
          name: "Gunanto Ferdinansyah Pratama",
          aspek: "Aspek Keselamatan Pertambangan",
          statusDocument: "-",
          submitDate: "10/FEB/2025",
        },
      ],
      dataNC: [],
      totalDataApproved: 0,
      totalDataInfo: 0,
      totalDataRevision: 0,
    };
  },
  mounted() {
    this.role = this.userData.role;
    this.sioID = this.$route.params.id;
    this.kontraktorid = this.userData.kontraktorID;
    this.getSioID(this.kontraktorid);
  },
  methods: {
    capitalized(name) {
      if (name != null) {
        const capitalizedFirst = name[0].toUpperCase();
        const rest = name.slice(1);

        return capitalizedFirst + rest;
      }
    },
    getSioID(id) {
      axios
        .get(url_get_sioid + id, {
          headers: {
            role: this.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response nya = ", response);

          let dt = null;
          dt = response.data.data;
          if (dt != null) {
            this.dataSio = dt;
            this.sioID = dt.id;
            this.getJadwalSio(this.sioID);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    getJadwalSio(idsio) {
      axios
        .get(url_get_jadwal + idsio, {
          headers: {
            role: this.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response getJadwalSio :  ", response);
          let dt = response.data;
          this.idPenjadwalan = dt.idPenjadwalan;
          if (dt.idPenjadwalan != null) {
            this.getPenilaianDetail(this.idPenjadwalan);
            this.getListNC();
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getJadwalSio : " + error);
          console.error("Error fetching data getJadwalSio :", error);
        });
    },
    getPenilaianDetail() {
      let bodyJson = {
        idPenjadwalan: this.idPenjadwalan,
        jenis: "administrasi",
      };

      axios
        .post(url_get_penilaiandetail, bodyJson, {
          headers: {
            role: "kontraktor",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response getPenilaianDetail : ", response);
          if (response.data !== undefined && response.data !== null) {
            let dt = response.data;
            this.dataPJO.nama = dt.pjo;
            this.dataPJO.perusahaan = dt.perusahaan;
            this.dataPJO.tanggalPresentasi = dt.schedule;
            this.statusSio = dt.statusSio;
            this.kustodians = dt.kustodians;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error getPenilaianDetail : ", error);
          alert("error getPenilaianDetail : ", error);
        })
        .then(() => {});
    },
    getListNC({ page, itemsPerPage } = {}) {
      if (page) {
        this.currentPage = page;
      }
      if (itemsPerPage) {
        this.perPage = itemsPerPage;
      }
      if (!this.idPenjadwalan) {
        return;
      }
      let bodyJson = {
        idPenjadwalan: this.idPenjadwalan,
        role: "kontraktor",
        page: this.currentPage,
        perPage: this.perPage,
      };

      axios
        .post(url_get_list_nc, bodyJson, {
          headers: {
            role: "kontraktor",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          let result = {};
          result.data = response.data.data;
          result.total_data = response.data.totalData;
          result.total_per_page = this.perPage;
          result.current_page = this.currentPage;
          this.dataTable = SetDataTableResponse(this.dataTable, result);

          this.dataNC = response.data.data;
          this.totalData = response.data.totalData;
          this.totalDataApproved = response.data.totalDataApproved;
          this.totalDataInfo = response.data.totalInfo;
          this.totalDataRevision = response.data.totalRevision;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error getListNC : ", error);
          alert("error getListNC : ", error);
        })
        .then(() => {});
    },
    handleChangeFile(idx) {
      let files = null;
      files = this.$refs["fileNC" + idx].files;
      if (files) {
        // console.log(files);
        for (let i = 0; i < files.length; i++) {
          // Check file type
          if (files[i].type !== "application/pdf") {
            alert("Ekstensi file harus .pdf!");
            this.$refs["fileNC" + idx].value = "";
            return;
          }
          if (files[i].size > max_file_size * 1024 * 1024) {
            alert("Ukuran file melebihi batas max " + max_file_size + "MB !");
            this.$refs["fileNC" + idx].value = "";
            return;
          }
        }
        this.dataNC[idx].fileNC = files;
      }
      console.log(this.dataNC[idx].fileNC);
    },
    async uploadFile(index) {
      // let file = this.dataNC[index].fileNC[0];
      let arrAssets = [];
      let files = this.dataNC[index].fileNC;
      console.log("files:", files);
      for (let x = 0; x < files.length; x++) {
        let file = files[x];
        if (file) {
          // Get the file name
          const fileName = file.name;

          // Create a FormData object and append the file
          const formData = new FormData();
          formData.append("file", file);
          console.log("filename : ", fileName);
          // Make the API request to upload the file
          try {
            const response = await axios.post(url_upload_file_nc, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                role: this.userData.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            });

            // Handle the response from the server as needed
            console.log("response up file pk: ", response);
            console.log("File upload response:", response.data);

            let fname =
              response.data.filename != "" && response.data.filename != null
                ? response.data.filename
                : null;
            let jsonAssets = { actual_name: fileName, filename: fname };
            arrAssets.push(jsonAssets);
            if (x == files.length - 1) {
              this.tempAssets = JSON.stringify(arrAssets);
              this.prosesSimpanNC(index);
              this.$refs["fileNC" + index].value = "";
            }
          } catch (error) {
            // Handle errors, e.g., display an error message to the user
            alert("error");
            // alert(error.message)
            // if (error.response.data != null) {
            //     alert(error.response.data.message)
            // }
            this.isLoading = false;
            console.error("Error uploading file:", error);
            // this.$router.go(this.$router.currentRoute)
          }
        }
      }
    },
    prosesSimpanNC(index) {
      console.log(index);
      let bodyJson = {
        // "status": 'open',
        assets: this.tempAssets,
        updatedBy: this.userData.email,
        id: this.dataNC[index].idNc,
        // "dueDate": duedate,
        // "rejectReason": null,
      };
      axios
        .post(url_set_nc, bodyJson, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then(() => {
          Swal.fire({
            title: "Update Data NC",
            text: "File Revisi NC berhasil disimpan!",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then(() => {
            // this.$router.back()
            window.location.reload();
            // this.getListNC();
          });
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error prosesSimpanNC : ", error);
          alert("error prosesSimpanNC : ", error);
        })
        .then(() => {});
    },
    clickSimpan(index) {
      // console.log(this.dataNC[index]);
      this.isLoading = true;
      if (
        this.dataNC[index].fileNC != null &&
        this.dataNC[index].fileNC != undefined
      ) {
        this.uploadFile(index);
      } else {
        this.isLoading = false;
        alert("Lengkapi File sesuai NC yang disimpan !");
      }
    },
    viewFile(fileName) {
      window.open(url_view_document + fileName, "_blank");
    },
  },
};
</script>
